import { useMutation } from '@tanstack/react-query';
import { apiDeletePrioShareFile } from '../../../api';

interface DeletePrioShareFileParams {
  projectExtensionId: string;
  prioShareId: string;
  prioShareFileId: string;
}

export function useDeletePrioShareFile() {
  return useMutation({
    mutationFn: async (params: DeletePrioShareFileParams) => {
      return apiDeletePrioShareFile(
        params.projectExtensionId,
        params.prioShareId,
        params.prioShareFileId
      );
    },
  });
}
